import styled from "@emotion/styled"
import { Box, Paper } from "@mui/material"

export const ConsultaContainer = styled(Box)`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
`

export const Formulario = styled(Paper)`
    padding: 1rem;
    width: 100%;
`

export const ButtonsContainer = styled(Box)`
    margin-top: 1rem;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`